import { render, staticRenderFns } from "./VInvoice.vue?vue&type=template&id=179990b9&scoped=true"
import script from "./VInvoice.vue?vue&type=script&lang=js"
export * from "./VInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179990b9",
  null
  
)

export default component.exports